// Documentação do arquivo - Atualização 25/04/2025::
// Este arquivo contém a implementação do PermissionGuard, que é um guardião de rota.
// Ele verifica se o usuário tem as permissões necessárias para acessar uma rota específica. Se o usuário não tiver as permissões necessárias, ele será redirecioconst hasPermissao = requiredPermissoes.some(p => userPermissoes.includes(p));do para a página de "Acesso Negado".

import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const requiredPermissoes = route.data['permissoes'] as string[];

    const userPermissoes = this.authService.getPermissoes();
    let hasPermissao = false;
    if (userPermissoes == 'Admin') {
      hasPermissao = true;
    } else {
      hasPermissao = requiredPermissoes.some(p => userPermissoes.includes(p));
    }
    // verificando se o usuario tem todas as permissões

    if (!hasPermissao) {
      this.router.navigate(['/home']);
      return false;
    }
    return true;
  }
}
